import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { useTheme } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import TagComponent from "@meetyoo/components/src/components/Tag";
import { defaultPasscodeTheme } from "../../../../constants/passCodeUtils";
import EditModalWarning from "../Modal/EditModalWarning";
import { spliceTag } from "../../../../utils/objectMethods/tagOperations";
import TableLayoutActions from "./TableLayoutActions";
import TableConfigurator from "./TableConfigurator";
import Cell from "./TableCell";

export const TableLayoutComponent = ({ row, colorMap, setOpenFilter, type, tableLayout, setFilter, username }) => {
  const theme = useTheme();
  const s = useMemo(
    () => ({
      ...defaultPasscodeTheme(theme),
      field: { px: 2 },
      ellipsis: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        cursor: "pointer",
        maxWidth: "420px",
      },
      noEllipsis: {
        maxWidth: "420px",
      },
      tag: {
        pt: "2px",
        px: theme.spacing(0, 0.25),
      },
      inlineTitle: { display: "flex" },
      inline: {
        display: "flex",
        maxWidth: "100%",
        flexWrap: "wrap",
      },
    }),
    [theme]
  );
  const [titleClicked, setTitleClicked] = useState(false);
  const [openModalWarning, setOpenModalWarning] = useState(false);

  return [
    <TableRow key="ticket-data" id={row.id} hover tabIndex={0}>
      <TableLayoutActions type={type} row={row} setOpenModal={setOpenModalWarning} />
      <TableCell
        onClick={() => setTitleClicked(!titleClicked)}
        sx={[s.field, !titleClicked ? s.ellipsis : s.noEllipsis]}
        id={row.title}
        padding="none"
      >
        <Box sx={s.inlineTitle}>{row.title}</Box>
        <Box sx={s.inline}>
          {row.tags.map((item, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <Box key={item + idx} sx={s.tag}>
              <TagComponent key={item} text={spliceTag(item)} color={colorMap[spliceTag(item)]} />
            </Box>
          ))}
        </Box>
      </TableCell>
      {tableLayout.map(item => {
        return item !== "title" ? (
          <Cell
            key={"cell " + item}
            value={row[item]}
            item={item}
            toolTip={
              TableConfigurator[item].toolTip && TableConfigurator[item].value(row[item]) !== -1
                ? TableConfigurator[item].toolTip(row[item])
                : undefined
            }
            type={TableConfigurator[item].type}
            onClickSearch={
              TableConfigurator[item].onClickSearch && !(type === "closed" && item === "webcastID")
                ? () => {
                    setOpenFilter(true);
                    setFilter(row[item], [item]);
                  }
                : undefined
            }
          />
        ) : null;
      })}
    </TableRow>,
    <EditModalWarning
      key="edit-modal-warning"
      row={row}
      setOpenModal={() => setOpenModalWarning(false)}
      openModal={openModalWarning}
    />,
  ];
};

TableLayoutComponent.defaultProps = {
  filterObject: undefined,
};

TableLayoutComponent.propTypes = {
  row: PropTypes.object.isRequired,
  colorMap: PropTypes.object.isRequired,
  setOpenFilter: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  tableLayout: PropTypes.array.isRequired,

  username: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  colorMap: state.projectmail.colorMap,
  lastWorkedTicket: state.projectmail.lastWorkedTicket,
  tableLayout: state.projectmail.tableLayout[ownProps.type],
  username: state.oauth.username,
});
const TableLayout = connect(mapStateToProps)(TableLayoutComponent);

export default TableLayout;
